import { TextareaHTMLAttributes, forwardRef } from 'react'

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  charCount?: number
  maxChars?: number
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ label, error, charCount, maxChars, className = '', id, ...props }, ref) => {
    const textareaId = id || label?.toLowerCase().replace(/\s+/g, '-')
    const isOverLimit = maxChars && charCount !== undefined && charCount > maxChars

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={textareaId} className="label">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          className={`input min-h-[100px] resize-y ${error || isOverLimit ? 'input-error' : ''} ${className}`}
          aria-invalid={!!error || !!isOverLimit}
          aria-describedby={error ? `${textareaId}-error` : undefined}
          {...props}
        />
        <div className="flex justify-between mt-1">
          {error && (
            <p id={`${textareaId}-error`} className="text-sm text-error">
              {error}
            </p>
          )}
          {charCount !== undefined && maxChars && (
            <p className={`text-sm ml-auto ${isOverLimit ? 'text-error' : 'text-secondary-text'}`}>
              {charCount}/{maxChars}
            </p>
          )}
        </div>
      </div>
    )
  }
)

TextArea.displayName = 'TextArea'
